module.exports = __webpack_public_path__ + "img/4038f28.png";